<span
  class="item"
  [class.first]="isFirst"
  [class.selected]="isSelected"
  [class.bordered]="bordered"
>
  <span [class.with-notif]="numberOfNotifications > 0">
    <ng-content />
  </span>

  @if (numberOfNotifications > 0) {
    <span
      class="number-of-notifications"
      [class.three-digits]="numberOfNotifications > 99"
    >
      {{ numberOfNotifications < 100 ? numberOfNotifications : '99+' }}
    </span>
  }
</span>
